import { Check } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface WizardStep {
  id: number;
  label: string;
}

interface WizardStepperProps {
  steps: WizardStep[];
  currentStep: number;
  className?: string;
}

export function WizardStepper({ steps, currentStep, className }: WizardStepperProps) {
  return (
    <div className={cn('flex items-center justify-between', className)}>
      {steps.map((step, index) => {
        const isCompleted = step.id < currentStep;
        const isCurrent = step.id === currentStep;
        const isUpcoming = step.id > currentStep;

        return (
          <div key={step.id} className="flex items-center flex-1">
            {/* Step circle and label */}
            <div className="flex flex-col items-center">
              {/* Circle */}
              <div
                className={cn(
                  'w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold transition-all',
                  isCompleted && 'bg-indigo-500 text-white',
                  isCurrent && 'bg-indigo-500 text-white ring-4 ring-indigo-500/30',
                  isUpcoming && 'bg-slate-600 text-slate-300'
                )}
              >
                {isCompleted ? <Check size={16} strokeWidth={3} /> : step.id}
              </div>
              {/* Label */}
              <span
                className={cn(
                  'mt-2 text-xs font-medium uppercase tracking-wide whitespace-nowrap',
                  (isCompleted || isCurrent) && 'text-white',
                  isUpcoming && 'text-slate-400'
                )}
              >
                {step.label}
              </span>
            </div>

            {/* Connecting line (except for last step) */}
            {index < steps.length - 1 && (
              <div
                className={cn(
                  'flex-1 h-0.5 mx-3 mt-[-1.5rem]',
                  step.id < currentStep ? 'bg-indigo-500' : 'bg-slate-600'
                )}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}
